import { render, staticRenderFns } from "./MoveDepartmentTakeCareStudentModal.vue?vue&type=template&id=a34d04e2&scoped=true"
import script from "./MoveDepartmentTakeCareStudentModal.vue?vue&type=script&lang=js"
export * from "./MoveDepartmentTakeCareStudentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34d04e2",
  null
  
)

export default component.exports